import type {
  PrinterPageSize,
  PrinterType,
  PrinterRollWidth,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const printerCreateAtom = createMutationAtomFactory(
  'settings.printerCreate',
  (params: {
    sidecarId: string;
    uniqueId: string;
    driverType: string;
    name: string;
    printerType: PrinterType;
    pageSize?: PrinterPageSize;
    rollWidth?: PrinterRollWidth;
  }) => ({
    iotPrinterCreate: {
      __args: {
        input: {
          sidecarId: params.sidecarId,
          uniqueId: params.uniqueId,
          driverType: params.driverType,
          name: params.name,
          printerType: params.printerType,
          pageSize: params.pageSize,
          rollWidth: params.rollWidth,
        },
      },
      id: true,
      name: true,
      status: true,
      driverType: true,
      printerType: true,
    },
  }),
);
